/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Milliman.PullThroughPortal.WebAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface HcpLandscapeRow
 */
export interface HcpLandscapeRow {
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  presc_id?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  first_name?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  last_name?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  address?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  city?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  state?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  zip?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  product?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  client_flag?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  client?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  geography?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  level?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  channel?: string | null;
  /**
   *
   * @type {number}
   * @memberof HcpLandscapeRow
   */
  prod_trx?: number | null;
  /**
   *
   * @type {number}
   * @memberof HcpLandscapeRow
   */
  prod_nrx?: number | null;
  /**
   *
   * @type {number}
   * @memberof HcpLandscapeRow
   */
  mkt_trx?: number | null;
  /**
   *
   * @type {number}
   * @memberof HcpLandscapeRow
   */
  prod_share?: number | null;
  /**
   *
   * @type {number}
   * @memberof HcpLandscapeRow
   */
  fav_pct?: number | null;
  /**
   *
   * @type {number}
   * @memberof HcpLandscapeRow
   */
  acc_pct?: number | null;
  /**
   *
   * @type {number}
   * @memberof HcpLandscapeRow
   */
  delta_fa?: number | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  indication?: string | null;
  /**
   *
   * @type {string}
   * @memberof HcpLandscapeRow
   */
  time_period?: string | null;
  /**
   *
   * @type {number}
   * @memberof HcpLandscapeRow
   */
  comp_prod_trx?: number | null;
  /**
   *
   * @type {number}
   * @memberof HcpLandscapeRow
   */
  comp_prod_nrx?: number | null;
}

export function HcpLandscapeRowFromJSON(json: any): HcpLandscapeRow {
  return HcpLandscapeRowFromJSONTyped(json, false);
}

export function HcpLandscapeRowFromJSONTyped(json: any, ignoreDiscriminator: boolean): HcpLandscapeRow {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    presc_id: !exists(json, "presc_id") ? undefined : json["presc_id"],
    first_name: !exists(json, "first_name") ? undefined : json["first_name"],
    last_name: !exists(json, "last_name") ? undefined : json["last_name"],
    address: !exists(json, "address") ? undefined : json["address"],
    city: !exists(json, "city") ? undefined : json["city"],
    state: !exists(json, "state") ? undefined : json["state"],
    zip: !exists(json, "zip") ? undefined : json["zip"],
    product: !exists(json, "product") ? undefined : json["product"],
    client_flag: !exists(json, "client_flag") ? undefined : json["client_flag"],
    client: !exists(json, "client") ? undefined : json["client"],
    geography: !exists(json, "geography") ? undefined : json["geography"],
    level: !exists(json, "level") ? undefined : json["level"],
    channel: !exists(json, "channel") ? undefined : json["channel"],
    prod_trx: !exists(json, "prod_trx") ? undefined : json["prod_trx"],
    prod_nrx: !exists(json, "prod_nrx") ? undefined : json["prod_nrx"],
    mkt_trx: !exists(json, "mkt_trx") ? undefined : json["mkt_trx"],
    prod_share: !exists(json, "prod_share") ? undefined : json["prod_share"],
    fav_pct: !exists(json, "fav_pct") ? undefined : json["fav_pct"],
    acc_pct: !exists(json, "acc_pct") ? undefined : json["acc_pct"],
    delta_fa: !exists(json, "delta_fa") ? undefined : json["delta_fa"],
    indication: !exists(json, "indication") ? undefined : json["indication"],
    time_period: !exists(json, "time_period") ? undefined : json["time_period"],
    comp_prod_trx: !exists(json, "comp_prod_trx") ? undefined : json["comp_prod_trx"],
    comp_prod_nrx: !exists(json, "comp_prod_nrx") ? undefined : json["comp_prod_nrx"],
  };
}

export function HcpLandscapeRowToJSON(value?: HcpLandscapeRow | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    presc_id: value.presc_id,
    first_name: value.first_name,
    last_name: value.last_name,
    address: value.address,
    city: value.city,
    state: value.state,
    zip: value.zip,
    product: value.product,
    client_flag: value.client_flag,
    client: value.client,
    geography: value.geography,
    level: value.level,
    channel: value.channel,
    prod_trx: value.prod_trx,
    prod_nrx: value.prod_nrx,
    mkt_trx: value.mkt_trx,
    prod_share: value.prod_share,
    fav_pct: value.fav_pct,
    acc_pct: value.acc_pct,
    delta_fa: value.delta_fa,
    indication: value.indication,
    time_period: value.time_period,
    comp_prod_trx: value.comp_prod_trx,
    comp_prod_nrx: value.comp_prod_nrx,
  };
}
